/* ==========================================================================
   Clippiq — hareket motoru v2

   Tasarım ilkeleri
   · Kare başına düzen okuması yapılmaz. Konumlar bir kez ölçülür, her karede
     yalnızca window.scrollY ile hesap yapılır (layout thrash yok).
   · Paralaks ve scrub değerleri lerp ile yumuşatılır — kaydırmayı bıraksan
     bile hareket yumuşak biter.
   · Her efekt opt-in (data-*). İş bitince rAF döngüsü kendini durdurur.
   · prefers-reduced-motion açıksa her şey kapanır, içerik anında görünür olur.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var coarse = window.matchMedia('(hover: none)');
  var root = document.documentElement;

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }

  /* ======================================================================
     1. Metin bölme — kelime, harf ve gerçek satır kutusu
     ====================================================================== */
  function wrapUnits(el, mode) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) if (n.nodeValue.trim()) nodes.push(n);

    var out = [];
    nodes.forEach(function (textNode) {
      var frag = document.createDocumentFragment();
      var units = mode === 'chars'
        ? textNode.nodeValue.split('')
        : textNode.nodeValue.split(/(\s+)/);

      units.forEach(function (unit) {
        if (!unit) return;
        if (/^\s+$/.test(unit)) { frag.appendChild(document.createTextNode(unit)); return; }
        var s = document.createElement('span');
        s.className = 'clp-split__unit';
        s.textContent = unit;
        frag.appendChild(s);
        out.push(s);
      });
      textNode.parentNode.replaceChild(frag, textNode);
    });
    return out;
  }

  // Kelimeleri gerçek satır kutularına göre grupla, her satırı ayrı maskele.
  function splitLines(el, stagger, base) {
    var words = wrapUnits(el, 'words');
    if (!words.length) return;

    var lines = [];
    var curTop = null;
    words.forEach(function (w) {
      var top = Math.round(w.offsetTop);
      if (curTop === null || Math.abs(top - curTop) > 4) { lines.push([]); curTop = top; }
      lines[lines.length - 1].push(w);
    });

    lines.forEach(function (group, i) {
      var mask = document.createElement('span');
      mask.className = 'clp-split__line';
      var inner = document.createElement('span');
      inner.className = 'clp-split__line-in';
      inner.style.setProperty('--clp-split-delay', (base + i * stagger).toFixed(3) + 's');

      group[0].parentNode.insertBefore(mask, group[0]);
      group.forEach(function (w, k) {
        if (k > 0) inner.appendChild(document.createTextNode(' '));
        inner.appendChild(w);
      });
      mask.appendChild(inner);
    });
  }

  function splitInline(el, mode, stagger, base) {
    var units = wrapUnits(el, mode);
    units.forEach(function (u, i) {
      var mask = document.createElement('span');
      mask.className = 'clp-split__line';
      u.parentNode.insertBefore(mask, u);
      u.classList.add(mode === 'chars' ? 'clp-split__char' : 'clp-split__word');
      u.style.setProperty('--clp-split-delay', (base + i * stagger).toFixed(3) + 's');
      mask.appendChild(u);
    });
  }

  function splitText(el) {
    if (el.dataset.clpSplitDone === '1') return;
    el.dataset.clpSplitDone = '1';
    if (!el.dataset.clpSplitSource) el.dataset.clpSplitSource = el.innerHTML;

    var mode = el.getAttribute('data-split') || 'words';
    var stagger = parseFloat(el.getAttribute('data-split-stagger') || (mode === 'lines' ? '0.085' : '0.045'));
    var base = parseFloat(el.getAttribute('data-split-delay') || '0');

    if (mode === 'lines') splitLines(el, stagger, base);
    else splitInline(el, mode, stagger, base);
  }

  // Genişlik değişince satır bölmesi bozulur; yeniden kur.
  var lastSplitWidth = window.innerWidth;
  function resplit() {
    if (Math.abs(window.innerWidth - lastSplitWidth) < 40) return;
    lastSplitWidth = window.innerWidth;
    $$('[data-split="lines"]').forEach(function (el) {
      if (!el.dataset.clpSplitSource) return;
      var was = el.classList.contains('is-revealed');
      el.innerHTML = el.dataset.clpSplitSource;
      el.dataset.clpSplitDone = '';
      splitText(el);
      if (was) el.classList.add('is-revealed');
    });
  }

  /* ======================================================================
     2. Ortaya çıkma — gözlemci + garanti tarayıcı
     ====================================================================== */
  var revealObserver = null;
  var pending = [];

  function markRevealed(el) {
    el.classList.add('is-revealed');
    var i = pending.indexOf(el);
    if (i !== -1) pending.splice(i, 1);
    if (revealObserver) revealObserver.unobserve(el);
  }

  // Güvenlik ağı: gözlemci tetiklenmese bile görünür alana giren veya
  // geçilip üstte kalan her öge açılır. İçerik asla gizli kalmaz.
  function sweepReveals() {
    if (!pending.length) return;
    var vh = window.innerHeight;
    for (var i = pending.length - 1; i >= 0; i--) {
      if (pending[i].getBoundingClientRect().top < vh * 0.95) markRevealed(pending[i]);
    }
  }

  function setupReveals(scope) {
    var nodes = $$('[data-reveal], [data-split], .clp-img-reveal', scope || document);
    if (!nodes.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        if (el.hasAttribute('data-split')) splitText(el);
        el.classList.add('is-revealed');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) markRevealed(e.target); });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    }

    nodes.forEach(function (el) {
      if (el.dataset.clpRevealBound === '1') return;
      el.dataset.clpRevealBound = '1';

      if (el.hasAttribute('data-split')) splitText(el);

      var d = el.getAttribute('data-reveal-delay');
      if (d) el.style.setProperty('--clp-reveal-delay', parseFloat(d) + 's');

      pending.push(el);

      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { markRevealed(el); });
        });
        return;
      }
      revealObserver.observe(el);
    });
  }

  function setupStagger(scope) {
    $$('[data-reveal-group]', scope || document).forEach(function (group) {
      if (group.dataset.clpStaggerDone === '1') return;
      group.dataset.clpStaggerDone = '1';
      var step = parseFloat(group.getAttribute('data-reveal-group') || '0.09');
      var start = parseFloat(group.getAttribute('data-reveal-group-delay') || '0');
      Array.prototype.forEach.call(group.children, function (child, i) {
        if (!child.hasAttribute('data-reveal')) child.setAttribute('data-reveal', 'up');
        // Üstel yavaşlama: ilk ögeler hızlı gelir, sonrakiler biraz daha geç.
        var delay = start + step * (i + Math.pow(i, 1.35) * 0.08);
        child.style.setProperty('--clp-reveal-delay', delay.toFixed(3) + 's');
      });
    });
  }

  /* ======================================================================
     3. Scroll'a bağlı efektler — ölçüm bir kez, hesap her karede
     ====================================================================== */
  var scrollItems = [];
  var progressBar = null;

  function collect(scope) {
    $$('[data-parallax]', scope || document).forEach(function (el) {
      if (el.dataset.clpSBound === '1') return;
      el.dataset.clpSBound = '1';
      scrollItems.push({
        el: el, kind: 'parallax',
        amount: parseFloat(el.getAttribute('data-parallax')) || 0.12,
        // Medya ögelerinde kayma sırasında kenar açılmasın diye taban ölçek
        cover: el.hasAttribute('data-parallax-cover'),
        base: 1, travel: 0,
        cur: 0, target: 0, top: 0, h: 0
      });
    });
    $$('[data-scroll-scale]', scope || document).forEach(function (el) {
      if (el.dataset.clpScaleBound === '1') return;
      el.dataset.clpScaleBound = '1';
      scrollItems.push({
        el: el, kind: 'scale',
        amount: parseFloat(el.getAttribute('data-scroll-scale')) || 0.12,
        cur: 0, target: 0, top: 0, h: 0
      });
    });
    $$('[data-scrub]', scope || document).forEach(function (el) {
      if (el.dataset.clpScrubBound === '1') return;
      el.dataset.clpScrubBound = '1';
      scrollItems.push({ el: el, kind: 'scrub', cur: 0, target: 0, top: 0, h: 0 });
    });
    measure();
  }

  // getBoundingClientRect dönüştürülmüş ögede kaydırılmış değer döndürür ve
  // her ölçümde hata birikir. offsetTop/offsetHeight düzen tabanlıdır,
  // transform'dan etkilenmez — ölçümü onlarla yapıyoruz.
  function layoutTop(el) {
    var y = 0;
    var n = el;
    while (n) { y += n.offsetTop || 0; n = n.offsetParent; }
    return y;
  }

  function measure() {
    var vh = window.innerHeight;
    for (var i = 0; i < scrollItems.length; i++) {
      var it = scrollItems[i];
      it.top = layoutTop(it.el);
      it.h = it.el.offsetHeight || it.el.getBoundingClientRect().height || 1;
      if (it.kind === 'parallax') {
        // Toplam yol: viewport yüksekliğinin oranı kadar — görünür bir hareket.
        it.travel = it.amount * vh * 0.5;
        it.base = it.cover ? 1 + (Math.abs(it.travel) * 2) / it.h : 1;
      }
    }
  }

  var lastY = window.scrollY || 0;
  var lastT = performance.now();
  var smoothVel = 0;
  var running = false;
  var idleFrames = 0;

  // 60 fps'te 0.14 olan yumuşatma katsayısını geçen süreye göre ölçekler.
  // 30 fps'te de, 120 fps'te de hareket aynı sürede tamamlanır.
  function smoothing(base, dt) {
    return 1 - Math.pow(1 - base, dt);
  }

  function frame() {
    var vh = window.innerHeight;
    var sy = window.scrollY || window.pageYOffset;

    var now = performance.now();
    var dt = clamp((now - lastT) / 16.667, 0.2, 6);
    lastT = now;

    var velocity = sy - lastY;
    lastY = sy;
    smoothVel = lerp(smoothVel, clamp(velocity, -90, 90), smoothing(0.12, dt));
    root.style.setProperty('--clp-vel', smoothVel.toFixed(2));

    var busy = Math.abs(smoothVel) > 0.06;

    for (var i = 0; i < scrollItems.length; i++) {
      var it = scrollItems[i];
      var rel = it.top - sy;
      if (rel > vh + 320 || rel + it.h < -320) continue;

      if (it.kind === 'parallax') {
        var p = (rel + it.h / 2 - vh / 2) / (vh / 2 + it.h / 2);
        it.target = p * it.travel;
      } else if (it.kind === 'scale') {
        it.target = (1 - clamp((rel + it.h) / (vh + it.h), 0, 1)) * it.amount;
      } else {
        it.target = clamp((vh - rel) / (vh + it.h), 0, 1);
      }

      if (Math.abs(it.target - it.cur) > 0.0005) {
        it.cur = lerp(it.cur, it.target, smoothing(0.14, dt));
        busy = true;
      } else {
        it.cur = it.target;
      }

      if (it.kind === 'parallax') {
        var s = it.base !== 1 ? ' scale(' + it.base.toFixed(4) + ')' : '';
        it.el.style.transform = 'translate3d(0,' + it.cur.toFixed(2) + 'px,0)' + s;
      } else if (it.kind === 'scale') {
        it.el.style.transform = 'scale(' + (1 + it.cur).toFixed(4) + ')';
      } else {
        it.el.style.setProperty('--clp-progress', it.cur.toFixed(4));
      }
    }

    if (progressBar) {
      var max = document.documentElement.scrollHeight - vh;
      progressBar.style.transform = 'scaleX(' + clamp(max > 0 ? sy / max : 0, 0, 1).toFixed(4) + ')';
    }

    sweepReveals();

    idleFrames = (busy || pending.length) ? 0 : idleFrames + 1;
    if (idleFrames > 30) { running = false; return; }
    requestAnimationFrame(frame);
  }

  function start() {
    idleFrames = 0;
    if (running) return;
    running = true;
    requestAnimationFrame(frame);
  }

  /* ======================================================================
     4. Sayaç
     ====================================================================== */
  function setupCounters(scope) {
    var nodes = $$('[data-count-to]', scope || document);
    if (!nodes.length || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);

        var raw = el.getAttribute('data-count-to') || '0';
        var target = parseFloat(raw.replace(',', '.')) || 0;
        var decimals = (raw.split(',')[1] || raw.split('.')[1] || '').length;
        var prefix = el.getAttribute('data-count-prefix') || '';
        var suffix = el.getAttribute('data-count-suffix') || '';

        if (reduced.matches) { el.textContent = prefix + raw + suffix; return; }

        var dur = (parseFloat(el.getAttribute('data-count-duration')) || 1.9) * 1000;
        var t0 = performance.now();
        (function step(now) {
          var t = clamp((now - t0) / dur, 0, 1);
          var eased = 1 - Math.pow(1 - t, 4);
          el.textContent = prefix + (target * eased).toFixed(decimals).replace('.', ',') + suffix;
          if (t < 1) requestAnimationFrame(step);
        })(t0);
      });
    }, { threshold: 0.35 });

    nodes.forEach(function (el) {
      if (el.dataset.clpCountBound === '1') return;
      el.dataset.clpCountBound = '1';
      obs.observe(el);
    });
  }

  /* ======================================================================
     5. İşaretçi etkileşimleri
     ====================================================================== */
  function setupPointer(scope) {
    if (coarse.matches || reduced.matches) return;

    $$('[data-magnetic]', scope || document).forEach(function (el) {
      if (el.dataset.clpMagnetBound === '1') return;
      el.dataset.clpMagnetBound = '1';
      var strength = parseFloat(el.getAttribute('data-magnetic')) || 0.24;
      var rx = 0, ry = 0, tx = 0, ty = 0, raf = null;

      var mLast = performance.now();
      function loop() {
        var mNow = performance.now();
        var mdt = clamp((mNow - mLast) / 16.667, 0.2, 6);
        mLast = mNow;
        var k = 1 - Math.pow(1 - 0.18, mdt);
        rx = lerp(rx, tx, k);
        ry = lerp(ry, ty, k);
        el.style.transform = 'translate3d(' + rx.toFixed(2) + 'px,' + ry.toFixed(2) + 'px,0)';
        if (Math.abs(rx - tx) > 0.1 || Math.abs(ry - ty) > 0.1) raf = requestAnimationFrame(loop);
        else { raf = null; if (!tx && !ty) el.style.transform = ''; }
      }
      function kick() { if (!raf) raf = requestAnimationFrame(loop); }

      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        tx = (e.clientX - r.left - r.width / 2) * strength;
        ty = (e.clientY - r.top - r.height / 2) * strength;
        kick();
      });
      el.addEventListener('pointerleave', function () { tx = 0; ty = 0; kick(); });
    });

    $$('[data-tilt]', scope || document).forEach(function (el) {
      if (el.dataset.clpTiltBound === '1') return;
      el.dataset.clpTiltBound = '1';
      var max = parseFloat(el.getAttribute('data-tilt')) || 5;

      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        el.style.setProperty('--clp-mx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--clp-my', (py * 100).toFixed(1) + '%');
        el.style.transform =
          'perspective(1000px) rotateX(' + ((0.5 - py) * max).toFixed(2) +
          'deg) rotateY(' + ((px - 0.5) * max).toFixed(2) + 'deg) translate3d(0,-2px,0)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });

    $$('.button, .clp-spotlight, [data-glow]', scope || document).forEach(function (el) {
      if (el.dataset.clpGlowBound === '1') return;
      el.dataset.clpGlowBound = '1';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--clp-mx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        el.style.setProperty('--clp-my', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
      });
    });
  }

  /* ======================================================================
     6. Kayan şerit
     ====================================================================== */
  function setupMarquee(scope) {
    $$('.clp-marquee', scope || document).forEach(function (el) {
      if (el.dataset.clpMarqueeBound === '1') return;
      el.dataset.clpMarqueeBound = '1';
      var track = el.querySelector('.clp-marquee__track');
      if (!track) return;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      el.appendChild(clone);
    });
  }

  /* ======================================================================
     7. Başlık: yön duyarlı gizlenme
     ====================================================================== */
  function setupHeader() {
    var header = document.querySelector('.header-wrapper');
    if (!header || reduced.matches) return;
    var last = window.scrollY;

    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (Math.abs(y - last) < 6) return;
      var down = y > last;
      last = y;
      if (document.body.style.position === 'fixed') return;
      header.classList.toggle('is-hidden', down && y > 340);
    }, { passive: true });
  }

  /* ======================================================================
     8. İlerleme çubuğu
     ====================================================================== */
  function setupProgress() {
    if (reduced.matches || document.querySelector('.clp-progress')) return;
    var wrap = document.createElement('div');
    wrap.className = 'clp-progress';
    wrap.innerHTML = '<div class="clp-progress__bar"></div>';
    document.body.appendChild(wrap);
    progressBar = wrap.firstChild;
  }

  /* ======================================================================
     Başlat
     ====================================================================== */
  var sweepTimer = null;
  function startSweepLoop() {
    if (sweepTimer) return;
    sweepTimer = setInterval(function () {
      if (!pending.length) { clearInterval(sweepTimer); sweepTimer = null; return; }
      sweepReveals();
    }, 350);
  }

  function init(scope) {
    setupStagger(scope);
    setupReveals(scope);
    collect(scope);
    setupCounters(scope);
    setupPointer(scope);
    setupMarquee(scope);
    startSweepLoop();
    start();
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { resplit(); measure(); start(); }, 180);
  }

  function boot() {
    root.classList.add('clp-motion-ready');
    setupProgress();
    setupHeader();
    init(document);

    window.addEventListener('scroll', start, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', function () { measure(); sweepReveals(); start(); });
    window.addEventListener('pageshow', function () { measure(); sweepReveals(); start(); });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { resplit(); measure(); });
    }
    // Görseller yüklendikçe konumlar kayar; birkaç kez yeniden ölç.
    [400, 1200, 2500].forEach(function (ms) {
      setTimeout(function () { measure(); start(); }, ms);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.clpMotion = {
    init: init, measure: measure, splitText: splitText,
    debug: function () {
      return scrollItems.map(function (i) {
        return { cls: (i.el.className || '').slice(0, 28), kind: i.kind, top: Math.round(i.top),
                 h: Math.round(i.h), travel: Math.round(i.travel || 0), base: +(i.base || 1).toFixed(3),
                 cur: +i.cur.toFixed(2), target: +i.target.toFixed(2) };
      });
    }
  };
})();
